module.exports = "/_next/static/images/12-2078af3db9b5a006574381a7233b83f4.png";